



























































































import CommonBase from "../CommonBase";
import {Component, Inject, Prop} from "vue-property-decorator";
import Api from "./Api";
import {DateTime, PhoneNumber} from "../../modules/models";
import {BadRequest, NotAuthenticated} from "../../modules/PlayServerClient";
import TopHdr from "./TopHdr.vue";
import {redirect} from "@/modules/utils";
import rd from "@/modules/vRoutedefs";
import SigninIcon from "@/components/SigninIcon.vue";
import {phoneCheck, phoneCheckedLocation} from "@/modules/LoginFlow";
import {NativeApi} from "@/modules/NativeBridge";
import {ignoreRedundantNavErr} from "@/router";

// This component handles result of checking for possible logins with given phone number.
// Results of check is determined by looking at props pendingCreated and confirmedCreated.
// If pendingCreated is set and less than one hour ago, next step will be to confirm it. User may also reply that
// pending is not found, which will move on to check if confirmedCreated is set.
// If confirmedCreated is set, next step will be either logging in with it, or ask for code renewal text message.
// If neither is set, next step will be to register a new user on the phone number.
@Component({
    components: {
        "at-top-hdr": TopHdr,
        "at-signin-icon": SigninIcon,
    }
})
export default class PhoneChecked extends CommonBase {
    @Inject()
    api!: Api;
    @Inject()
    nativeApi!: NativeApi;

    @Prop()
    phone!: PhoneNumber;
    @Prop()
    pendingCreated!: DateTime | null;
    @Prop()
    confirmedCreated!: DateTime | null;
    @Prop({default: ""})
    redir!: string;

    showPass = false;
    pass: string = "";
    errMsg: string = "";

    toggleShowPass() {
        this.showPass = !this.showPass;
    }

    get pendingExpirationTime(): DateTime | null {
        if(this.pendingCreated == null) {
            return null;
        }
        // created plus one hour. Limit is set in person.sql, person_get_pending_person_phone_row
        return this.pendingCreated.plusMillis(1000*60*60);
    }
    get pendingValid() {
        return this.pendingExpirationTime && DateTime.now().isBefore(this.pendingExpirationTime);
    }

    get routedefs() {
        return rd;
    }

    freshConfirmedDate!: DateTime;

    freshConfirmedCode() {
        return this.confirmedCreated && this.confirmedCreated.isAfter(this.freshConfirmedDate);
    }

    get pendingCreatedString() {
        return this.pendingCreated ? this.pendingCreated.isToday() ? ` kl ${this.pendingCreated.toLocalTime()}` : ` den ${this.pendingCreated.toLocalDate()} kl ${this.pendingCreated.toLocalTime()}` : null;
    }
    get confirmedCreatedString() {
        return this.confirmedCreated ? this.confirmedCreated.isToday() ? ` kl ${this.confirmedCreated.toLocalTime()}` : ` den ${this.confirmedCreated.toLocalDate()} kl ${this.confirmedCreated.toLocalTime()}` : null;
    }

    get displayPasswordInput() {
        return this.pendingValid || this.confirmedCreated !== null;
    }

    checkPass() {
        if(this.pass.length == 0) {
            return "Kode må fylles ut";
        }
        const passCode = Number(this.pass);
        if(passCode > 0) {
            return true;
        } else {
            return "Ugyldig innloggingskode. Koden skal bestå av tall."
        }
    }

    async login() {
            this.working = true;
            try {
                const cp = this.checkPass();
                if(cp === true) {
                    await this.api.login(this.phone.toString(), this.pass, this.nativeApi);
                    const redirTo = this.redir !== "" ? this.redir : rd.start.path;
                    redirect(redirTo);
                } else {
                    this.errMsg = cp;
                }
            } catch (err) {
                if (err instanceof NotAuthenticated) {
                    if (err.num === 38 || err.num === 39) { // Wrong password, or no existing phone number found
                        const passCode = Number(this.pass);
                        // Check if there is pending ckey for the given credentials.
                        const ckeyCheck = await this.api.getLoginCkey(this.phone, passCode);
                        if (ckeyCheck.num == 60) {
                            const ckey = ckeyCheck.msg;
                            await ignoreRedundantNavErr(this.$router.push({name: this.routedefs.login.keylogin.name, query: {ckey: ckey, redir: this.redir}})); // Redirect to handle pending idcard phone confirm

                        } else if (err.num === 39) { // only check for pending person pass if login error was 39 (and not 38)
                            // Check if there is pending pkey for the given credentials.
                            const pkeyCheck = await this.api.getLoginPkey(this.phone, passCode); // See if there is pending phone login for the number/pass
                            if (pkeyCheck.num == 54) {
                                const pkey = pkeyCheck.msg;
                                await ignoreRedundantNavErr(this.$router.push({name: this.routedefs.login.keylogin.name, query: {pkey: pkey, redir: this.redir}})); // Redirect to handle pending phone confirm
                            } else if (pkeyCheck.num === 36) {
                                this.errMsg = "Mobilnummer ikke registrert, eller bekreftet for sent.";
                            } else {
                                this.errMsg = pkeyCheck.msg;
                            }
                        } else { // Other login error
                            this.errMsg = err.message;
                        }
                    } else {
                        this.emitError(err);
                    }
                } else {
                    this.emitError(err);
                }
            } finally {
                this.working = false;
            }
    }


    working = false;

    async loginRenew() {
        this.working = true;
        this.errMsg = "";
        try {
            const msg = await this.api.loginRenew(this.phone.toString());
            if(msg.length > 0) {
                this.snackMsg(msg);
            }
            const checkReply = await phoneCheck(this.phone, this.api);
            this.errMsg = checkReply.errorMsg || checkReply.phoneInvalidMsg || "";
            if(this.errMsg === "") {
                await ignoreRedundantNavErr(this.$router.replace(phoneCheckedLocation(this.phone, checkReply.pendingCreated, checkReply.confirmedCreated, this.redir)));
            }
        } catch(err) {
            if(err instanceof BadRequest) {
                this.errMsg = err.message;
            } else {
                throw err;
            }
        } finally {
            this.working = false;
        }
    }


    snackMsg(msg: string) {
        this.$emit("at-snack", msg);
    }

    beforeCreate() {
        this.freshConfirmedDate = DateTime.now().prevDay().prevDay().prevDay().prevDay().prevDay(); // Five days ago
    }
}
